import { UpdateApiDto } from '../models/api/dto'
import axiosClient from './axiosClient'

const PATH = '/apis'

export const apiApi = {
  getApis: () =>
    axiosClient.get(PATH, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  updateApi: (id: number, updateApiDto: UpdateApiDto) =>
    axiosClient.put(`${PATH}/${id}`, updateApiDto, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),
}
